import type { IRequestSerialized, IRequestSerializer } from '../interface/requestSerializer';

function _serializeHeaders(headers: Headers): any {
    const serialized: Record<any, any> = {};

    for (const pair of (headers as any).entries()) {
        const key = pair[0];
        const value = pair[1];
        serialized[key] = value;
    }

    return serialized;
}

function serializeRequest(request: Request): Promise<IRequestSerialized> {
    const serialized: IRequestSerialized = {
        url: request.url,
        headers: _serializeHeaders(request.headers),
        method: request.method,
        mode: request.mode,
        credentials: request.credentials,
        cache: request.cache,
        redirect: request.redirect,
        referrer: request.referrer,
        referrerPolicy: request.referrerPolicy,
        isHistoryNavigation:
            (request as unknown as IRequestSerialized)?.isHistoryNavigation || false,
        isReloadNavigation: (request as unknown as IRequestSerialized)?.isReloadNavigation || false,
        integrity: request.integrity,
        destination: request.destination,
        body: '',
    };

    /* Only if method is not `GET` or `HEAD` is the request allowed to have body. */
    if (request.method === 'GET') {
        return Promise.resolve(serialized);
    }
    if (request.method === 'HEAD') {
        return Promise.resolve(serialized);
    } else {
        return request
            .clone()
            .text()
            .then(function (body) {
                serialized.body = body;
                return Promise.resolve(serialized);
            });
    }
}

function deserializeRequest(requestIn: IRequestSerialized): Request {
    const request = new Request('', requestIn);
    return request;
}

function serializer(): IRequestSerializer {
    const val: IRequestSerializer = {
        serialize: serializeRequest,
        parse: deserializeRequest,
    };

    return val;
}

export default serializer;
